/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct GovernanceStructs.ContractUpgrade",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseGuardianSetUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "address[]",
                                name: "keys",
                                type: "address[]",
                            },
                            {
                                internalType: "uint32",
                                name: "expirationTime",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct Structs.GuardianSet",
                        name: "newGuardianSet",
                        type: "tuple",
                    },
                    {
                        internalType: "uint32",
                        name: "newGuardianSetIndex",
                        type: "uint32",
                    },
                ],
                internalType: "struct GovernanceStructs.GuardianSetUpgrade",
                name: "gsu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedSetMessageFee",
                type: "bytes",
            },
        ],
        name: "parseSetMessageFee",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "messageFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct GovernanceStructs.SetMessageFee",
                name: "smf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedTransferFees",
                type: "bytes",
            },
        ],
        name: "parseTransferFees",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "recipient",
                        type: "bytes32",
                    },
                ],
                internalType: "struct GovernanceStructs.TransferFees",
                name: "tf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
export class GovernanceStructs__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
GovernanceStructs__factory.bytecode = _bytecode;
GovernanceStructs__factory.abi = _abi;
